<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-row>
            <b-col cols="12">
                <FormInput 
                    label="Nombre" 
                    type="text" 
                    name="nombre" 
                    id="nombre" 
                    rules="required" 
                    v-model="remitenteForm.nombre"
                    :disabled="loading" 
                />
            </b-col>
            <b-col cols="12">
                <FormInput 
                    label="Email" 
                    type="email" 
                    name="email" 
                    id="email" 
                    rules="required" 
                    v-model="remitenteForm.email"
                    :disabled="loading" 
                />
            </b-col>
            <b-col cols="12">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="default" v-model="remitenteForm.default" :disabled="loading" />
                    <label for="default" class="custom-control-label pt-1">Establecer como remitente por defecto</label>
                </div>
            </b-col>
            <b-col cols="12" class="text-right mt-3">
                <Button type="submit" :disabled="loading">Continuar</Button>
            </b-col>
        </b-row>
    </ValidationObserver>
</template>

<script>
    export default {
        props: {
            remitente: {
                type: Object,
                required: true
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                remitenteForm: { ...this.remitente }
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.$emit('terminado', this.remitenteForm);
                }
            }
        }
    }
</script>